import React from 'react';
import PropTypes from 'prop-types';

import {
	innerWrapperStyle,
	wrapperStyle,
	titleStyle,
	textStyle,
  resourceWrapper,
} from 'inside-out/page-styles/medicare';

import {
  purple,
  blue,
	contentSection,
} from 'inside-out/global-styles';

import { ResourceCard } from 'inside-out/components/shared/cards/resourceCard'
import { ComingSoon } from 'inside-out/components/shared/comingSoon'

import TSDImg from 'inside-out/images/medicare/tsd.png'
import stethoscopeImg from 'inside-out/images/medicare/stethoscope.png'
import typeformImg from 'inside-out/images/medicare/typeform.png'

const MedicarePreparingYourPracticePage = () => (
  <div className={wrapperStyle}>
    <section className={contentSection()}>
      <div className={innerWrapperStyle}>
        <h1 className={titleStyle} style={{color: purple}}>Get Training</h1>
        <div className={textStyle}>
          <p>All health professionals who plan to deliver services covered under the Eating Disorder Plan items must be appropriately trained. Our online training packages provide introductory training in treating eating disorders. We encourage interested clinicians to additionally access further specialised training and ongoing supervision.</p>

          <p>Check out InsideOut's suite of eLearning courses <a href="/e-learning">here</a>.</p>
        </div>
      </div>
    </section>

    <section className={contentSection('#FFF')}>
      <div className={innerWrapperStyle}>
        <h1 className={titleStyle}>The Approved Psychological Treatments to be Delivered Under Medicare</h1>
        <div className={textStyle}>
          <ul>
            <li>Family Based Treatment for Eating Disorders (EDs) (including whole family, Parent Based Therapy, parent only or separated therapy)</li>
            <li>Adolescent Focused Therapy for EDs</li>
            <li>Cognitive Behavioural Therapy (CBT) for EDs (CBT-ED)</li>
            <li>CBT-Anorexia Nervosa (AN) (CBT-AN)</li>
            <li>CBT for Bulimia Nervosa (BN) and Binge-eating Disorder (BED) (CBT-BN and CBT BED)</li>
            <li>Specialist Supportive Clinical Management (SSCM) for EDs</li>
            <li>Maudsley Model of Anorexia Treatment in Adults (MANTRA)</li>
            <li>Interpersonal Therapy (IPT) for BN, BED</li>
            <li>Dialectical Behavioural Therapy (DBT) for BN, BED</li>
          </ul>
        </div>
      </div>
    </section>

    <section className={contentSection()}>
      <div className={innerWrapperStyle}>
        <h1 className={titleStyle}>Training Required to Deliver Approved Treatments</h1>
        <div className={textStyle}>
          Our online training packages for mental health professionals and dietitians provide introductory training in treating eating disorders. Along with these introductory trainings you will need to demonstrate competency in the evidence based packages you deliver under the EDP.
        </div>
      </div>
    </section>


    <section className={contentSection('#FFF')}>
      <div className={innerWrapperStyle}>
        <a href="/resource-library/the-essentials-training-clinicians-in-eating-disorders" style={{ textDecoration: 'none' }}>
          <ComingSoon
            title="The Essentials eLearning Program"
            body="The only online program meeting the NEDC competency framework specified by Medicare."
            background={ blue }
            image={ stethoscopeImg }
          />
        </a>
        <div style={{display: 'flex' }}>
          <div className={resourceWrapper}>
            <ResourceCard
              background={ null }
              to={ '/resource-library/mbs-treatment-options-and-training' }
              audiences={ [] }
              title={ 'MBS Treatment Options and Training' }
              body={ 'An overview of the services that can be provided under the MBS eating disorder items, associated readings and trainings for health professionals.' }
              date={ '1 Nov, 2019' }
            />
          </div>
          <div className={resourceWrapper}>
            <ResourceCard
              background={ null }
              to={ '/events/save-the-date-cognitive-behavioural-therapy-for-bulimia-nervosa-and-binge-eating-disorder' }
              audiences={ [] }
              title={ 'CBT for Bulimia Nervosa and Binge Eating Disorder' }
              body={ 'This 2-day workshop will provide a comprehensive introduction to Cognitive Behavioural Therapy (CBT), and an overview of key cognitive behavioural treatment concepts for Bulimia Nervosa/ Binge Eating Disorder (as per the Medicare items).' }
              date={ '1 Nov, 2019' }
            />
          </div>
          <div className={resourceWrapper}>
            <ResourceCard
              background={ null }
              to={ '/resource-library/coming-soon-nutrition-management-of-eating-disorders-in-the-community' }
              audiences={ [] }
              title={ 'Dietitian Essentials: The Treatment of Eating Disorders' }
              body={ 'This highly interactive program includes expert videos, case studies, quizzes and provides downloadable resources. The course is a beginner to intermediate practice-based program and takes approximately six hours to complete.' }
              date={ '1 Nov, 2019' }
            />
          </div>
        </div>
      </div>
    </section>

    <section className={contentSection()}>
      <div className={innerWrapperStyle}>
        <h1 className={titleStyle} style={{color: purple }}>Get Listed</h1>
        <div className={textStyle}>
          Our Treatment Services Database is a national publicly available directory for health professionals with an interest in eating disorders. As such, a lot of people looking to receive care for an eating disorder use this service, and many organisations will be linking to our database to find practitioners.
        </div>
      </div>
    </section>

    <section className={contentSection('#FFF')}>
      <div className={innerWrapperStyle}>
        <h1 className={titleStyle}>List yourself on our database</h1>
        <div style={{display: 'flex' }}>
          <a href="/treatment-services">
            <img src={ TSDImg } alt="Treatment Services Database" />
          </a>
          <a href="https://cedd.typeform.com/to/eJjefF">
            <img src={ typeformImg } alt="List yourself on our database" style={{ height: '300px'}} />
          </a>
        </div>
      </div>
    </section>
  </div>
);

export { MedicarePreparingYourPracticePage }



// WEBPACK FOOTER //
// ./src/components/medicare/for-health-professionals/preparing-your-practice.js